export enum TransactionType {
  LIFTING = 'lifting',
  LOWERING = 'lowering',
  CLAIM_LOWERS = 'claim-lowers',
  ALL = 'all',
}

export type Transaction = {
  id: string;
  when: string;
  type: TransactionType;
  amount: number;
  txHash?: string;
  block: string | number;
  addressEWC: string;
  addressEWX: string;
  isPending: boolean | null;
  isFinalized: boolean | null;
  lowerId?: number | null;
  lowerPendingProof?: string | null;
  encodedLowerProof?: string | null;
  readyToBeClaimed?: boolean | null;
  claimed?: boolean | null;
  claimBlockNumber?: string | null;
  target?: string | null;
};

export type ClaimLower = {
  id: string;
  type: TransactionType;
  when: string;
  amount: number;
  txHash: string;
  block: string | number;
  addressEWX: string;
  addressEWC: string;
  lowerPendingProof: string | null;
  readyToBeClaimed: boolean | null;
  claimed: boolean | null;
  claimBlockNumber: string | null;
  isPending: boolean | null;
  isFinalized: boolean | null;
};
